// Define Redux Types For Dynamic Naming
export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';
export const SELECTED_AIRLINE = 'SELECTED_AIRLINE';
export const NEW_AIRLINE_CARD = 'NEW_AIRLINE_CARD';

export const ACTIVE_LOADING = 'ACTIVE_LOADING';
export const DEACTIVATE_LOADING = 'DEACTIVATE_LOADING';

export const SET_LOADING = 'SET_LOADING';
export const SET_BILLER = 'SET_BILLER';
export const SET_BILLER_LIST = 'SET_BILLER_LIST';
export const SET_BILLER_PREFIX = 'SET_BILLER_PREFIX';
export const SET_SERVICE = 'SET_SERVICE';
export const SET_MAINTENANCE = 'SET_MAINTENANCE';

export const SET_FORM = 'SET_FORM';
export const SET_FORM_LIST = 'SET_FORM';
export const SET_FORM_DATA = 'SET_FORM_DATA';
export const SET_CHECKOUT = 'SET_CHECKOUT';
export const UPDATE_CHECKOUT_PARAM = 'UPDATE_CHECKOUT_PARAM';
export const UPDATE_CHECKOUT_ERROR_MESSAGE = 'UPDATE_CHECKOUT_ERROR_MESSAGE';
export const SET_DEVICE_HEIGHT = 'SET_DEVICE_HEIGHT';
export const SET_AGREE_TNC = 'SET_AGREE_TNC';

export const SET_INVOICE = 'SET_INVOICE';

export const SET_ERROR_STATE = 'SET_ERROR_STATE';

export const RESET_FORM_PAGE = 'RESET_FORM_PAGE';

export const SET_ADDITIONAL_INFO = 'SET_ADDITIONAL_INFO';

export const SET_USER_AGREEMENTS = 'SET_USER_AGREEMENTS';
